import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const t = localStorage.getItem("cd_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const errText = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return e?.message || "Something went wrong";
};

export const fileUrl = (fileId) => `${process.env.REACT_APP_BACKEND_URL}/api/files/${fileId}`;

export default api;
